import { Tag } from "components/DesignSystem/Tag/Tag";
import {
  SUBMITTED,
  TASK_AMENDMENT_COMPLETED,
  FORM_FILING,
  TASK_AMENDMENT,
} from "constants/taskStates";
import { useRoleBasedView } from "hooks/useRoleBasedView";

import { Task } from "types/Models/task";

const TASK_STATUS = {
  Processing: "gray",
  Completed: "green",
  Archived: "gray",
};

export const TaskStatus = ({
  status,
  statusType: statusTypeFromProps,
  state,
}: {
  status?: string;
  statusType?: string;
  state?: Task["state"];
}) => {
  const { isCpa, isAdmin } = useRoleBasedView();

  if (isCpa || isAdmin) {
    const statusType = statusTypeFromProps;
    const isStatusFinal =
      statusType === SUBMITTED || statusType === TASK_AMENDMENT_COMPLETED;
    const isStatusInitial =
      (statusType === FORM_FILING ||
        state === null ||
        statusType === TASK_AMENDMENT) &&
      statusType !== SUBMITTED &&
      statusType !== TASK_AMENDMENT_COMPLETED;
    const isStatusInprogress =
      statusType !== FORM_FILING &&
      state !== null &&
      statusType !== SUBMITTED &&
      statusType !== TASK_AMENDMENT_COMPLETED &&
      statusType !== TASK_AMENDMENT;

    let tagType = "gray";

    if (isStatusFinal && !isStatusInitial && !isStatusInprogress) {
      tagType = "green";
    }

    return (
      <Tag
        icon={false}
        // @ts-ignore
        tagType={tagType}
        rounded
      >
        {(typeof state === "string" ? state : state?.name) || "Not started"}
      </Tag>
    );
  }

  return (
    <Tag
      icon={false}
      tagType={
        status === "Action required"
          ? "red"
          : // @ts-ignore
            TASK_STATUS[status]?.toString()
      }
      rounded
    >
      {status || "-"}
    </Tag>
  );
};
